module.exports = __webpack_public_path__ + "img/tent.3c0df53e.png";